import { gql } from '@apollo/client';
import { EMBEDED_TREE_FIELDS } from "../tree";
import { CONTROL_FIELDS } from "./control";
import { PARAMETER_FIELDS } from "./parameter";
export const PHONE_FIELDS = gql`
  fragment PhoneFields on PhoneDto {
    type
    prefix
    number
  }
`;
export const ADDRESS_FIELDS = gql`
  fragment AddressFields on AddressDto {
    door
    number
    countryCode
    postalCode
    stairs
    locality
    district
    name
    floor
    additionalNameInformation1
    additionalNameInformation2
    type
  }
`;
export const PERSON_FIELDS = gql`
  ${PHONE_FIELDS}
  ${ADDRESS_FIELDS}
  ${CONTROL_FIELDS}
  ${PARAMETER_FIELDS}
  fragment PersonFields on PersonDto {
    id
    businessUnitId
    businessUnitName
    creationTimestamp
    timestamp
    identityDocument {
      document
      type
    }
    birthDate
    maidenName
    matrimonialRegime
    email
    emailAddresses
    phone {
      ...PhoneFields
    }
    phones {
      ...PhoneFields
    }
    name
    surname
    surname2
    workCompanyName
    socialSecurityNumber
    sex
    streetAddress {
      ...AddressFields
    }
    streetAddresses {
      ...AddressFields
    }
    profession
    cno
    laborRelationship
    nativeCountry
    nativeProvince
    activitySector
    nationalities
    externalReference
    legal
    resident
    language
    nativeCity
    parameters {
      ...ParameterFields
    }
    controls {
      ...ControlFields
    }
  }
`;
export const CUSTOMER_FIELDS = gql`
  ${PERSON_FIELDS}
  fragment CustomerFields on CustomerDto {
    externalReference
    businessUnit {
      name
      code
      id
    }
    endDate
    name
    id
    account
    startDate
    status
    person {
      ...PersonFields
    }
  }
`;
export const CUSTOMER_FIELDS_WITHOUT_PERSON = gql`
  fragment CustomerFieldsWithoutPerson on CustomerDto {
    externalReference
    businessUnit {
      name
      code
      id
    }
    endDate
    name
    id
    account
    startDate
    status
  }
`;
export const USER_FIELDS = gql`
  ${PERSON_FIELDS}
  fragment UserFields on UserDto {
    id
    alias
    language
    locked
    email
    phoneNumber
    phonePrefix
    username
    person {
      ...PersonFields
    }
    businessUnit {
      name
      code
      id
    }
    businessUnits {
      name
      code
      id
    }
    userPicture
    roles {
      id
      name
    }
  }
`;
export const MY_DATA_FIELDS = gql`
  fragment MyDataFields on MyDataDto {
    phone
    prefix
    email
  }
`;
export const USER_FIELDS_WITHOUT_PERSON = gql`
  fragment UserFieldsWithoutPerson on UserDto {
    id
    alias
    locked
    username
    language
  }
`;
export const BUSINESS_UNIT_FIELDS = gql`
  fragment BusinessUnitFields on BusinessUnitDto {
    id
    name
    code
  }
`;
export const TYPOLOGY_TEMPLATE_FIELDS = gql`
  fragment TypologyTemplateFields on DocumentTypeDto {
    id
    name
    code
    formatList
    businessUnitId
    businessUnitName
    creationTimestamp
    createdBy
    modifiedBy
    timestamp
    documentTypes {
      id
      name
      code
      formatList
      businessUnitId
      businessUnitName
      creationTimestamp
      createdBy
      modifiedBy
      timestamp
    }
  }
`;
export const TYPOLOGY_FIELDS = gql`
  fragment TypologyFields on DocumentEdmDto {
    id
    archiveId
    archiveName
    archiveExtension
    name
    state
    documentTypeId
    documentTypeName
    documentTypeCode
    businessUnitName
    creationTimestamp
    createdBy
    modifiedBy
    timestamp
    level
  }
`;
export const ARCHIVE_FIELDS = gql`
  ${TYPOLOGY_FIELDS}
  fragment ArchiveFields on ArchiveDto {
    id
    name
    status
    businessUnitId
    businessUnitName
    creationTimestamp
    createdBy
    modifiedBy
    relatedId
    relatedObjectTypeId
    timestamp
    documents {
      ...TypologyFields
    }
  }
`;
export const FILE_FIELDS = gql`
  fragment FileFields on FileDto {
    name
    format
    size
    content
  }
`;
export const CUT_AND_MERGE_INFO_FIELDS = gql`
  fragment CutAndMergeArchiveInfoFields on CutAndMergeArchiveInfoDto {
    archiveId
    archiveName
    mimeType
    suitableToCutOrMerge
    numberOfPages
  }
`;
export const ARCHIVE_WITH_FILE_FIELDS = gql`
  ${FILE_FIELDS}
  ${TYPOLOGY_FIELDS}
  fragment ArchiveWithFileFields on ArchiveDto {
    id
    name
    status
    businessUnitId
    businessUnitName
    creationTimestamp
    createdBy
    modifiedBy
    timestamp
    documents {
      ...TypologyFields
    }
    file {
      ...FileFields
    }
  }
`;
export const LINK_FIELDS = gql`
  fragment LinkFields on LinkDto {
    id
    name
    url
    relatedId
    relatedObjectTypeId
  }
`;
export const SIGNATURE_FIELDS = gql`
  ${PERSON_FIELDS}
  ${ARCHIVE_FIELDS}
  ${EMBEDED_TREE_FIELDS}
  fragment SignatureFields on ReadSignatureDto {
    documentTypeBeforeSignFileID
    signedArchive {
      ...ArchiveFields
    }
    templateID
    manual
    legalNotice
    otpSms
    top
    PDFMarker
    left
    documentTypeSignedFileID
    otpMail
    creationTimestamp
    width
    signedDate
    signableArchive {
      ...ArchiveFields
    }
    page
    id
    height
    order
    status
    signer {
      ...PersonFields
    }
    statusTree {
      ...EmbededTreeFields
    }
    otpParameters {
      code
      length
      formatCode
      otpChannelUsed
    }
  }
`;
export const SIGNATURE_PROCESS_FIELDS = gql`
  ${SIGNATURE_FIELDS}
  fragment SignatureProcessFields on ReadSignatureProcessDto {
    controlMails
    relatedObjectTypeID
    documentTypeReportFileID
    resendSignEmailTemplateID
    language
    legalNotice
    documentTypeXmlFileID
    signatures {
      ...SignatureFields
    }
    relatedID
    processTemplateID
    signEmailTemplateID
    name
    creationTimestamp
    processCancelEmailTemplateID
    signedDate
    expireDate
    processSignedEmailTemplateID
    id
    resendDownloadEmailTemplateID
    status
    type
    f2fSigningUrl
    statusTree {
      ...EmbededTreeFields
    }
  }
`;
export const ATTACHMENT_FIELDS = gql`
  fragment AttachmentFields on AttachmentDto {
    id
    name
    notes
    creationTimestamp
    createdBy
    beginDate
    endDate
  }
`;
export const CASES_FIELDS = gql`
  fragment CasesFields on CasesDto {
    id
    businessUnitId
    name
    creationTimestamp
    timestamp
    createdBy
    modifiedBy
    priority
    state
    problem
    remarks
    startDate
    estimateDate
    endDate
    validDate
  }
`;
export const TEMPLATE_TEXT_FIELDS = gql`
  fragment TemplateTextFields on TemplateTextDto {
    id
    name
    code
    template
    editorHTML
    docValidation
    language
  }
`;
export const TEXT_FIELDS = gql`
  ${TEMPLATE_TEXT_FIELDS}
  fragment TextFields on TextDto {
    id
    name
    creationTimestamp
    businessUnitId
    businessUnitCodename
    status
    textTemplate {
      ...TemplateTextFields
    }
    text
    relatedObjectTypeID
    relatedID
  }
`;
export const INTERACTION_FIELDS = gql`
  fragment InteractionFields on InteractionDto {
    id
    name
    creationTimestamp
    createdBy
    businessUnitId
    businessUnitCodename
    subject
    interactionType
    relatedObjectTypeID
    relatedID
  }
`;
export const SMS_FIELDS = gql`
  fragment SmsFields on SmsDto {
    name
    creationTimestamp
    id
    createdBy
  }
`;
export const EMAIL_FIELDS = gql`
  fragment EmailFields on EmailDto {
    subject
    sendDate
    from
    to
    id
    body
    emailStatus
  }
`;
export const COMBO_FIELDS = gql`
  fragment ComboFields on ComboEntry {
    value
    label
  }
`;
export const ENUM_FIELDS = gql`
  fragment EnumFields on EnumEntry {
    value
    label
  }
`;
export const STRING_PAIR_FIELDS = gql`
  fragment StringPairFields on StringPairDto {
    key
    value
  }
`;